import { StringMapping, ValueMapping } from "@opendaw/lib-std";
import { Devices } from "../../DeviceAdapter";
import { ParameterAdapterSet } from "../../ParameterAdapterSet";
export class StereoToolDeviceBoxAdapter {
    type = "audio-effect";
    accepts = "audio";
    #context;
    #box;
    #parametric;
    namedParameter; // let typescript infer the type
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#parametric = new ParameterAdapterSet(this.#context);
        this.namedParameter = this.#wrapParameters(box);
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get indexField() { return this.#box.index; }
    get labelField() { return this.#box.label; }
    get enabledField() { return this.#box.enabled; }
    get minimizedField() { return this.#box.minimized; }
    get host() { return this.#box.host; }
    deviceHost() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    terminate() { this.#parametric.terminate(); }
    #wrapParameters(box) {
        return {
            volume: this.#parametric.createParameter(box.volume, ValueMapping.decibel(-72.0, 0.0, 12.0), StringMapping.numeric({ unit: "db", fractionDigits: 1 }), "Volume"),
            panning: this.#parametric.createParameter(box.panning, ValueMapping.bipolar(), StringMapping.panning, "Panning", 0.5),
            stereo: this.#parametric.createParameter(box.stereo, ValueMapping.bipolar(), StringMapping.numeric({ unit: "%", fractionDigits: 0 }), "stereo", 0.5),
            invertL: this.#parametric.createParameter(box.invertL, ValueMapping.bool, StringMapping.bool, "Invert Left"),
            invertR: this.#parametric.createParameter(box.invertR, ValueMapping.bool, StringMapping.bool, "Invert Right"),
            swap: this.#parametric.createParameter(box.swap, ValueMapping.bool, StringMapping.bool, "Swap")
        };
    }
}
